<template>
  <div class="flex flex-col bg-white min-h-screen">
    <page-header :hide_navbar="hide_navbar"></page-header>
    <section1></section1>
    <section2></section2>
    <page-footer></page-footer>
  </div>
</template>
<script>
import PageHeader from "./components/header.vue";
import PageFooter from "./components/footer.vue";
import Section1 from "./sections/newsletter_page/section1.vue";
import Section2 from "./sections/newsletter_page/section2.vue";

export default {
    name: "about",
    props: {
      hide_navbar: String,
    },
    components: { PageHeader, Section1, Section2,PageFooter},
    data() {
        return {
        };
  },
}
</script>
<style lang="scss" scoped>
</style>